/** Local calendar date as ISO `YYYY-MM-DD`.
 *
 * Uses the user's local timezone, **not** UTC, so a 00:30 CEST workout
 * counts for that calendar day (T-035 B2).
 */
export function localIsoDate(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
